import { storyblokEditable } from '@storyblok/react'

export default ({ blok }) => {
    return (
        <li className="discover-categories-item" {...storyblokEditable(blok)}>
            <a href={blok?.link?.url} className="block btn">{blok?.title}</a>
        </li>
    )
}
